'use client';

import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import LoginForm from '@/app/sign-up-login-screen/components/LoginForm';
import RegisterForm from '@/app/sign-up-login-screen/components/RegisterForm';
import ForgotPasswordForm from '@/app/sign-up-login-screen/components/ForgotPasswordForm';
import BrandPanel from '@/app/sign-up-login-screen/components/BrandPanel';

export type AuthView = 'login' | 'register' | 'forgot';

export interface LoginFormData {
  email: string;
  password: string;
  remember: boolean;
}

export default function AuthLoginPage() {
  const [mounted, setMounted] = useState(false);
  const [view, setView] = useState<AuthView>('login');

  const loginForm = useForm<LoginFormData>({
    defaultValues: { email: '', password: '', remember: false },
  });

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </main>
    );
  }

  return (
    <div className="min-h-screen flex">
      <BrandPanel />
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-10 bg-background overflow-y-auto">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl gradient-brand flex items-center justify-center">
              <span className="text-white font-bold text-sm">MBS</span>
            </div>
            <div>
              <p className="font-bold text-foreground">Marketing Biz Solutions</p>
              <p className="text-xs text-muted-foreground">AI Platform</p>
            </div>
          </div>

          {view !== 'forgot' && (
            <div className="flex bg-muted rounded-xl p-1 mb-8">
              {(['login', 'register'] as const).map((tab) => (
                <button
                  key={`tab-${tab}`}
                  onClick={() => setView(tab)}
                  suppressHydrationWarning
                  className={`flex-1 py-2 text-sm font-semibold rounded-lg transition-all duration-200 ${
                    view === tab
                      ? 'bg-card text-foreground shadow-card'
                      : 'text-muted-foreground hover:text-foreground'
                  }`}
                >
                  {tab === 'login' ? 'Sign In' : 'Create Account'}
                </button>
              ))}
            </div>
          )}

          {view === 'login' && (
            <LoginForm form={loginForm} onForgotPassword={() => setView('forgot')} />
          )}
          {view === 'register' && (
            <RegisterForm onSuccess={() => setView('login')} />
          )}
          {view === 'forgot' && (
            <ForgotPasswordForm onBack={() => setView('login')} />
          )}

          <p className="text-center text-xs text-muted-foreground mt-8">
            By continuing, you agree to our{' '}
            <a href="#" className="text-primary hover:underline">Terms of Service</a>
            {' '}and{' '}
            <a href="#" className="text-primary hover:underline">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
}
